<template>
  {{! template-lint-disable no-bare-strings }}
  <h1>Start page for testing</h1>
</template>
